/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

require('./components/homepage-slider');
require('./components/carousel-component');
require('./components/menucard-component');
require('./components/agenda-filter-component');
require('./components/agenda-live-feed-component');
require('./components/donation-form-component');
require('./components/productions-filter-component');
require('./components/faq-component');
require('./components/page-slider');
require('./components/search-component');
require('./components/cookie-message-component');
require('./components/image-text-block-slider');
require('./components/load-more-news-component');
require('./components/tour-slider');
require('./components/organisers-component');
require('./components/map-component');
require('./components/newsletter-signup-component');
require('./components/events-columns');
require('./components/location-google-map-component');
require('./components/text-split');
require('./components/repeating-words-component');
require('./components/carousel-titles-component');
require('./components/image-textblock-animation-component');
require('./components/video-component');
require('./components/add-event-form-component');
require('./components/file-upload-component');
require('./components/banqueting-page-component');
require('./components/newsletter-popup-component');

import Vue from 'vue';
import 'lazysizes';
import 'intersection-observer';
import scrollama from 'scrollama';
import lottie from 'lottie-web';
import Rellax from 'rellax';
import Headroom from 'headroom.js';

import thtLogoAnimation1 from './animations/logo-opbouw-01';
import thtLogoAnimation2 from './animations/logo-switch-01';
// import 'intersection-observer';
// import Router from './router';

import { debounce } from 'lodash';

import { gsap } from 'gsap';

const App = new Vue({
    el: '#app',
    delimiters: ['${', '}'],

    data() {
        return {
            showMobileNavigation: false,
            showSearch: false,
            animationThtLogo1: null,
            animationThtLogo2: null,
            header: null,
            headroom: null,
        }
    },

    mounted() {
        window.addEventListener('resize', this.onWindowResize);

        var menu = document.querySelector('.sticky');

        const rellax = new Rellax('.rellax', {
            // center: true
        });


        // var controller = new ScrollMagic.Controller();
        // var scene = new ScrollMagic.Scene({ triggerElement: '#header', offset: 106, duration: 300})
        // .setPin("#sticky")
        // // .addIndicators({name: "1 (duration: 300)"}) // add indicators (requires plugin)
        // .addTo(controller);

        this.initThtLogo();
        this.intersect();

        var logoHorizontal = document.querySelector('.header__logo--horizontal');
        var logoSquare = document.querySelector('.header__logo--square');

        window.addEventListener('scroll', () => {
            if (window.scrollY < 50) {
                // logoHorizontal.classList.remove('show');
                // logoSquare.classList.remove('hide');

                // this.animationThtLogo2.stop();
                if (this.animationThtLogo2) {
                    this.animationThtLogo2.setDirection(-1);
                    this.animationThtLogo2.play();
                }
            } else {
                if (logoHorizontal) {
                    logoHorizontal.classList.add('show');
                }
                if (logoSquare) {
                    logoSquare.classList.add('hide');
                }

                if (this.animationThtLogo1) {
                    this.animationThtLogo1.stop();
                }
                // gsap.delayedCall(1, () => {
                if (this.animationThtLogo2) {
                    this.animationThtLogo2.setDirection(1);
                    this.animationThtLogo2.play();
                }
                // });
            }
        });

        this.header = document.querySelector('#header');

        if (this.header) {
            this.headroom = new Headroom(this.header, {
                onUnpin: () => {
                    const newsletter = document.querySelector('.newsletter-popup-holder');

                    if (window.innerWidth < 768 && newsletter) {
                        gsap.to('.newsletter-popup-holder', {
                            top: 0,
                            duration: 0.2,
                            ease: 'linear'
                        });
                    }
                },

                onPin: () => {
                    const newsletter = document.querySelector('.newsletter-popup-holder');

                    if (window.innerWidth < 768 && newsletter) {
                        gsap.to('.newsletter-popup-holder', {
                            top: '106px',
                            duration: 0.2,
                            ease: 'linear'
                        });
                    }
                }
            });
            this.headroom.init();
        }

        this.initBasicFadeReveals();
    },

    methods: {
        toggleMobileMenu(event) {
            this.showMobileNavigation = !this.showMobileNavigation;

            if (this.showMobileNavigation) {
                gsap.set('body', {
                    overflow: 'hidden'
                });
                return;
            }

            gsap.set('body', {
                overflow: null
            });
        },

        // toggleSearch(event) {
        //     this.showSearch = !this.showSearch;
        // },

        /**
         * Raised when the client window is resizing.
         *
         * @return {Void}
         */
        onWindowResize: debounce(() => {
            EventBus.$emit('window-resize');
        }, 150),

        detectMobile() {
            this.isMobile = (window.innerWidth <= 768);
            this.isTablet = (window.innerWidth <= 1024);
            console.log(`Is Mobile: ${this.isMobile}`)
        },

        // Added for woeker campaign logo video
        intersect() {
            const lazyVideos = [].slice.call(this.$el.querySelectorAll('video.lazy'));
            let lazyVideoObserver = null;

            if ('IntersectionObserver' in window) {
                lazyVideoObserver = new IntersectionObserver((entries, observer) => {
                    entries.forEach((video) => {
                        if (video.isIntersecting) {
                            Object.keys(video.target.children).forEach((source) => {
                                const videoSource = video.target.children[source];
                                if (typeof videoSource.tagName === 'string' && videoSource.tagName === 'SOURCE') {
                                    videoSource.src = videoSource.dataset.src;
                                }
                            });

                            video.target.load();
                            video.target.classList.remove('lazy');
                            lazyVideoObserver.unobserve(video.target);
                            // if (/iPad|iPhone|iPod/.test(navigator.userAgent)) { video.target.autoplay = true; }

                            video.target.addEventListener('loadeddata', (e) => {
                                // Video should now be loaded but we can add a second check for certainty
                                // if (video.target.readyState >= 3) {
                                // gsap.delayedCall(0.5, () => {
                                video.target.play();

                                const videoInterval = setInterval(() => {
                                    const isVideoPlaying = !!(video.target.currentTime > 0 && !video.target.paused && !video.target.ended && video.target.readyState > 2);
                                    if (isVideoPlaying) {
                                        this.videoPlaying = true;
                                        clearInterval(videoInterval);
                                    } else {
                                        video.target.play();
                                    }
                                }, 500);
                                // });
                                // }
                            });
                        }
                    });
                });
            }
            lazyVideos.forEach((lazyVideo) => {
                if (lazyVideoObserver) {
                    lazyVideoObserver.observe(lazyVideo);
                }
            });
        },

        initThtLogo() {
            const thtLogoElementSquare = document.querySelector('.header__logo--square');
            if (thtLogoElementSquare) {
                const animationData = thtLogoAnimation1;
                this.animationThtLogo1 = lottie.loadAnimation({
                    container: thtLogoElementSquare,
                    renderer: 'svg',
                    loop: false,
                    autoplay: false,
                    animationData,
                    rendererSettings: {
                        progressiveLoad: false,
                    }
                });

                gsap.delayedCall(0.5, () => {
                    this.animationThtLogo1.play();
                });
            }

            const thtLogoElementHorizontal = document.querySelector('.header__logo--horizontal');
            if (thtLogoElementHorizontal) {
                const animationData = thtLogoAnimation2;
                this.animationThtLogo2 = lottie.loadAnimation({
                    container: thtLogoElementHorizontal,
                    renderer: 'svg',
                    loop: false,
                    autoplay: false,
                    animationData,
                    rendererSettings: {
                        progressiveLoad: false,
                    }
                });
            }
        },

        // tempToggle(event) {
        //     const element = event.currentTarget;
        //     const parent = element.parentNode;

        //     const collapse = parent.querySelector('.filter-overlay__filter-item-options');

        //     if (collapse.classList.contains('open')) {
        //         collapse.classList.remove('open')
        //         gsap.to(collapse, { height: 0 });
        //         return;
        //     }

        //     collapse.classList.add('open');
        //     gsap.to(collapse, { height: 'auto' });
        // },

        initBasicFadeReveals() {
            gsap.set('.basic-reveal', { opacity: 0, y: '100%' });

            const scroller = scrollama();

            // setup the instance, pass callback functions
            scroller
                .setup({
                    step: '.basic-reveal',
                    offset: 0.95,
                })
                .onStepEnter(response => {
                    // { element, index, direction }
                    // console.log('Entered')
                    gsap.to(response.element, { opacity: 1, y: 0, ease: "power4.out", duration: 1 });
                })
                .onStepExit(response => {
                });

            // setup resize event
            window.addEventListener('resize', scroller.resize);
        }
    },

    beforeDestroy() {
        window.removeEventListener('resize', this.fadeUpScroll.resize);
        window.removeEventListener('resize', this.onWindowResize);
    }
});
